import React from 'react';
import {CommonCreate} from '../Common';
import {getInputs} from './Common';

export const ContainerCreate = props => (
  <CommonCreate
    {...{
      ...props,
      fields: getInputs(),
    }}
  />
);
